import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Recipes from './pages/Recipes';
import CreateRecipe from './pages/CreateRecipe';
import CreateAI from './pages/CreateAI';
import RecipeDetails from './pages/RecipeDetails';
import RecipeInstructions from './pages/RecipeInstructions';
import Community from './pages/Community';
import Videos from './pages/Videos';
import VideoDetails from './pages/VideoDetails';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/recipes/create" element={<CreateRecipe />} />
              <Route path="/recipes/create/:id" element={<CreateRecipe />} />
              <Route path="/recipes/create/:recipeId/instructions" element={<RecipeInstructions />} />
              <Route path="/recipes/create-ai" element={<CreateAI />} />
              <Route path="/recipes/:id" element={<RecipeDetails />} />
              <Route path="/community" element={<Community />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/videos/:videoId" element={<VideoDetails />} />
            </Route>
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
